module.exports = __webpack_public_path__ + "img/logo-ticketshop-carousel.a6268aae.png";